'use strict';

exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: 'निर्धारित',
      clear: 'स्पष्ट'
    },
    datepicker: {
      now: 'अब',
      today: 'आज',
      cancel: 'रद्द करना',
      clear: 'स्पष्ट',
      confirm: 'निर्धारित',
      selectDate: 'तारीख़ चुनें',
      selectTime: 'समय चुनें',
      startDate: 'आरंभ करने की तिथि',
      startTime: 'समय शुरू',
      endDate: 'अंतिम तिथि',
      endTime: 'अंत समय',
      prevYear: 'पिछले वर्ष',
      nextYear: 'आगामी वर्ष',
      prevMonth: 'पिछला महीना',
      nextMonth: 'अगले महीने',
      year: 'साल',
      month1: 'जनवरी',
      month2: 'फरवरी',
      month3: 'मार्च',
      month4: 'अप्रैल',
      month5: 'मई',
      month6: 'जून',
      month7: 'जुलाई',
      month8: 'अगस्त',
      month9: 'सितंबर',
      month10: 'अक्टूबर',
      month11: 'नवंबर',
      month12: 'दिसंबर',
      week: 'सप्ताह',
      weeks: {
        sun: 'रविवार',
        mon: 'सोमवार',
        tue: 'मंगलवार',
        wed: 'बुधवार',
        thu: 'बृहस्पतिवार',
        fri: 'शुक्रवार',
        sat: 'शनिवार'
      },
      months: {
        jan: 'जनवरी',
        feb: 'फरवरी',
        mar: 'मार्च',
        apr: 'अप्रैल',
        may: 'मई',
        jun: 'जून',
        jul: 'जुलाई',
        aug: 'अगस्त',
        sep: 'सितंबर',
        oct: 'अक्टूबर',
        nov: 'नवंबर',
        dec: 'दिसंबर',
      }
    },
    select: {
      loading: 'लदान',
      noMatch: 'कोई आकड़ा उपलब्ध नहीं है',
      noData: 'कोई आकड़ा उपलब्ध नहीं है',
      placeholder: 'चुनते हैं'
    },
    cascader: {
      noMatch: 'कोई आकड़ा उपलब्ध नहीं है',
      loading: 'लदान',
      placeholder: 'चुनते हैं',
      noData: 'कोई आकड़ा उपलब्ध नहीं है'
    },
    pagination: {
      goto: 'के लिए जाओ',
      pagesize: '/पेज',
      total: 'कुल {total}',
      pageClassifier: 'पृष्ठ'
    },
    messagebox: {
      title: 'शीघ्र',
      confirm: 'निर्धारित',
      cancel: 'रद्द करना',
      error: 'अवैध इनपुट'
    },
    upload: {
      deleteTip: 'हटाने के लिए delete दबाएं',
      delete: '删除',
      preview: '查看图片',
      continue: '继续上传'
    },
    table: {
      emptyText: 'कोई आकड़ा उपलब्ध नहीं है',
      confirmFilter: 'फ़िल्टर',
      resetFilter: 'साथ रीसेट करें',
      clearFilter: 'सभी',
      sumText: 'कुल'
    },
    tree: {
      emptyText: 'कोई आकड़ा उपलब्ध नहीं है'
    },
    transfer: {
      noMatch: 'कोई आकड़ा उपलब्ध नहीं है',
      noData: 'कोई आकड़ा उपलब्ध नहीं है',
      titles: ['List 1', 'List 2'],
      filterPlaceholder: 'कुंजीशब्द दर्ज करें',
      noCheckedFormat: '{total} आइटम',
      hasCheckedFormat: '{checked}/{total} checked'
    },
    image: {
      error: 'लोड करने में विफल'
    },
    pageHeader: {
      title: 'लौटना'
    },
    popconfirm: {
      confirmButtonText: 'निर्धारित',
      cancelButtonText: 'रद्द करना'
    },
    empty: {
      description: 'कोई आकड़ा उपलब्ध नहीं है'
    }
  }
};


// WEBPACK FOOTER //
// ./src/i18n/el/hi.js